export { default } from './src/shade.jsx';